import React, { useMemo, useEffect, useCallback } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import style from './loyaltyCopy.module.scss';
import LoyaltyLightImg  from '@assets/images/loyaltyLight.png';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { TouchableButton } from '@components/common/Touchable'
import PropTypes from 'prop-types';


const LoyaltySignIn = (props) => {
  const {
    loyaltyMethod,
    loyaltyInfo,
    openLoyaltyKeyboard,
    serverAppTheme,
    joinClicked,
    alreadyMem,
    themeProperties,
    isLandScape,
    handleRouteToChecKListing,
    showCheckSeat
  } = props
  const getTheme = useMemo(() => {
    getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme)
  });
  const screenType = ["31"].includes((urlSearchParams("screenType")));
  const signInMethods = useMemo(() => {
    if (loyaltyMethod === 'signIn') {
      return loyaltyInfo.lookupMethods || [];
    } else if (loyaltyMethod === 'signUp') {
      return loyaltyInfo.signUpMethods || [];
    }
    return [];
  }, [loyaltyMethod, loyaltyInfo]);


  useEffect(() => {
    if (signInMethods.length === 1) {
      openLoyaltyKeyboard(signInMethods[0]);
    }
  }, [signInMethods]);

  const handleSignInMethodClick = (data) => {
    openLoyaltyKeyboard(data);
  };

  const handleMethodClick = useCallback((event, item) => {
    event.preventDefault();
    handleSignInMethodClick(item);
  }, [handleSignInMethodClick]);


  const getName = useCallback((methodName) => {
    switch (methodName) {
      case 'phone': return screenType ? LABEL().LS_PHONE : LABEL().LB_PHONE;
      case 'type': return LABEL().LS_ACCOUNT;
      case 'email': return screenType ? LABEL().LS_EMAIL : LABEL().LB_EMAIL;
      case 'swipe': return LABEL().LOYALTY_SWIPE;
      default: return LABEL().LOYALTY_SCAN;
    }
  }, []);



  return (
    <div className={cn("w-100 h-100 position-relative")}>
      {!isLandScape &&
      <div className="w-100 py-1 h-20 pt-2 pb-1">
        {(loyaltyMethod !== "signIn"
          ? themeProperties?.loyaltySignUpImageUrl?.length > 0
          : themeProperties?.loyaltySignInImageUrl?.length > 0) ? (
            <img
            loading="lazy"
            src={
              loyaltyMethod !== "signIn"
                ? themeProperties?.loyaltySignUpImageUrl
                : themeProperties?.loyaltySignInImageUrl
            }
            alt="signIn"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            className=""
          />
        ) : getTheme === "2" ? (
            <img
            loading="lazy"
            alt='loyaltyLight'
            src={LoyaltyLightImg}
            style={{ width: "100%", objectFit: "cover" }}
            className="h-100"
          />
        ) : (
              <img
              loading="lazy"
            alt='loyalty'
            src={LoyaltyLightImg}
            style={{ width: "100%", objectFit: "cover" }}
            className="h-100"
          />
        )}
      </div>
}
      <div
        className={cn("row mx-0 px-2 fs-32 justify-content-center", isLandScape ? `h-27 ${style.paddingLyalty}`: 'h-52' )}
        style={{ color: serverAppTheme?.primary_text }}
      >
        {!isLandScape &&
          <div className="col-12 px-0 py-2 text-center fs_24 fw-700">
            {" "}
            {joinClicked
              ? LABEL().LS_SIGN_UP_TO_LOYALTY
              : alreadyMem
                ? LABEL().LS_SIGN_IN_TO_LOYALTY
                : ""}
          </div>
        }
        <div
          className={cn("fw-400 fs_32 p-1 text-center")}
          style={{ color: serverAppTheme?.primary_text }}
        >
          {loyaltyMethod === "signIn"
            ? screenType ? CUSTOM_MESSAGES().LOYALTY_SIGN_IN_MESSAGE : CUSTOM_MESSAGES().LB_HOW_TO_HOW_WOULD_YOU_LIKE_TO_SIGN_IN_TODAY
            : screenType ? CUSTOM_MESSAGES().LOYALTY_JOIN_IN_MESSAGE : CUSTOM_MESSAGES().LB_HOW_WOULD_YOU_LIKE_TO_JOIN_TODAY}
        </div>
      </div>
      <div
        className={cn(
          "w-100 text-center h-30 align-self-end position-absolute d-flex align-items-end", isLandScape && "justify-content-center p-3"
        )}
        style={{ bottom: screenType ? isLandScape ? (showCheckSeat() ? '-20px' : '-35px') : 0 : "35px" }}>
        <div className={cn(isLandScape ? "w-50" : "w-100")}>
          {signInMethods?.map((item, index) => {
              return (
                item &&
                item !== "swipe" &&
                item !== "scan" && (
                  <TouchableButton
                    key={item}
                    type="button"
                    onClick={(event) => {
                      handleMethodClick(event, item)
                    }}
                    className={cn(
                      style.loyalty_btn,
                      isLandScape ? 'btn68' : style.join_btn_height,
                      "btn70 w-100 fw-50 btn-ripple od-primary-btn-bg-color od-primary-btn-font-color mb-2",
                    )}
                    style={{ fontFamily: "Poppins", height: !isLandScape ? "7.5vh" : '' }}
                    rippleEffect={true}
                  >
                    <div
                      className={cn("fs_28 fw-600")}
                    >{getName(item)}</div>
                  </TouchableButton>
                )
              );
            })}
          {!screenType &&
            <TouchableButton
              type="button"
              className={cn(
                "btn70 w-100 fw-50 btn-ripple d-flex align-items-center justify-content-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color",
                style.loyalty_btn,
                isLandScape ? 'btn68' : style.join_btn_height,
              )}
              style={{
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                color: serverAppTheme?.primary_text,
                border: "1px solid #2541A4",
                fontFamily: "Poppins",
                height: !isLandScape && "7.5vh"
              }}
              onClick={(e) => {
                e.preventDefault();
                handleRouteToChecKListing();
              }}
              rippleEffect={true}
            >
              <span className="fw-600 fs_28">{screenType ? LABEL().OLS_CANCEL : LABEL().LB_CANCEL}</span>
            </TouchableButton>
          }
        </div>
      </div>
    </div>
  );
};
LoyaltySignIn.propTypes = {
  loyaltyMethod: PropTypes.string,
  loyaltyInfo: PropTypes.object,
  openLoyaltyKeyboard: PropTypes.func,
  serverAppTheme: PropTypes.string,
  joinClicked: PropTypes.func,
  alreadyMem: PropTypes.bool,
  themeProperties: PropTypes.object,
  isLandScape: PropTypes.bool,
  handleRouteToChecKListing: PropTypes.func,
};
export default React.memo(LoyaltySignIn);
